// /d/$id — real route (design doc's G1/G4, public/SEO surface). Mirrors
// apps/web's app/d/[id]/page.tsx: a `'use client'` page reading its own `id`
// via next/navigation's useParams(). Public, no guard — replaces the
// placeholderRoute call in routes/core.tsx (ClientLayout already renders
// `/d/` chromeless).
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const PublicDashboardPage = lazy(() => import('@/app/d/[id]/page'));

export const shareDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/d/$id',
  component: PublicDashboardPage,
});
